import { action, makeObservable, observable, runInAction } from 'mobx';
import { Store } from '../../store/store';
import { StoreNode } from '../../store';
import { RouteContext } from '../../routes/routeContext';
import { AuthFlowResponse } from '../../services/auth/authFlowSchema';

export class OAuthLogoutPageState
  extends StoreNode {

  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      isLoading: observable,
      flowResponse: observable,
      error: observable,
      attached: action,
      detached: action,
      reset: action,
    });
  }

  isLoading = false;

  flowResponse: AuthFlowResponse | null = null;
  error: Error | null = null;

  async attached(routeContext: RouteContext) {

    this.reset();
    this.isLoading = true;

    const [res, err] = await this.store.authService.handleOAuthLogout(routeContext);
    if (err)
      this.error = err;
    else
      this.flowResponse = res;

    runInAction(() => {
      this.isLoading = false;
    });
  }

  detached() {
    this.reset();
  }

  reset() {
    this.flowResponse = null;
    this.error = null;
    this.isLoading = false;
  }
}